import { Badge, Flex, MenuProps } from '@mantine/core';
import { UseQueryResult } from '@tanstack/react-query';
import { NavigationRoutes } from 'common/constants';
import colors from 'common/constants/colors.styles';
import { ApiError } from 'common/repositories/common.model';
import useFilterHandleParent from 'hooks/filter/use-filter-handle-parent';
import Menu, { MenuDataType } from 'mantine-components/widget/menu';
import Text from 'mantine-components/widget/text';
import Link from 'next/link';
import UniskaiButton from 'templates/actions/uniskai-button';
import { PredefinedFirst } from 'types/helper.type';

export interface UniskaiListHeaderProps<T> {
  title: string;
  query?: UseQueryResult<T, ApiError>;
  onOpenPivot?: () => void;
  onOpenFilter?: () => void;
  menu?: MenuDataType[];
  menuProps?: MenuProps;

  showAdd?: boolean;
  addNavigation: PredefinedFirst<NavigationRoutes>;
  additionalRefresh?: () => void;
}

export default function UniskaiListHeader<T>(props: UniskaiListHeaderProps<T>) {
  const {
    query,
    menuProps,
    menu = [],
    showAdd = true,
    addNavigation,
    additionalRefresh,
    onOpenFilter,
    onOpenPivot,
    title,
  } = props;

  const { filtersHasValuesCount } = useFilterHandleParent();
  return (
    <Flex wrap="wrap" align="start" gap={16}>
      <Text variant="h5Medium" flex={1}>
        {title}
      </Text>
      <Flex gap={8}>
        {onOpenFilter && (
          <UniskaiButton
            type="filter"
            onClick={onOpenFilter}
            isResponsive={false}
            rightSection={
              !!filtersHasValuesCount && (
                <Badge children={filtersHasValuesCount} color={colors.blue} />
              )
            }
          />
        )}
        {!!query && (
          <UniskaiButton
            type="refresh"
            onClick={() => {
              query.refetch();
              additionalRefresh?.();
            }}
            loading={query.isLoading || query.isFetching}
          />
        )}
        {onOpenPivot && <UniskaiButton type="pivot" onClick={onOpenPivot} />}
        {!!showAdd && !!addNavigation && (
          <Link href={addNavigation} passHref>
            <UniskaiButton type="add" />
          </Link>
        )}
        {menu.length > 0 && (
          <Menu
            {...menuProps}
            data={menu}
            target={<UniskaiButton fullWidth type="action" />}
          />
        )}
      </Flex>
    </Flex>
  );
}
